import React from 'react';
import { Box, Paper, Typography } from '@mui/material';

interface PortalPlaceholderPageProps {
  title: string;
  /** Optional one-line explanation under the title. */
  blurb?: string;
  /** Show the "Coming soon" marker (default). Set false for an honest empty state. */
  comingSoon?: boolean;
}

/**
 * Minimal page for the new External-portal routes that later phases fill in (Profile → Phase 5,
 * Buy → Phase 6a). Only reachable under the `billingEnabled` IA, so a dark deployment never shows it.
 */
export const PortalPlaceholderPage: React.FC<PortalPlaceholderPageProps> = ({
  title,
  blurb,
  comingSoon = true,
}) => (
  <Box sx={{ p: 3 }}>
    <Typography variant="h5" sx={{ color: 'primary.main', fontWeight: 600, mb: 2 }}>
      {title}
    </Typography>
    <Paper variant="outlined" sx={{ p: 4, borderRadius: 3, textAlign: 'center' }}>
      {comingSoon && (
        <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 0.5 }}>
          Coming soon
        </Typography>
      )}
      {blurb && (
        <Typography variant="body2" color="text.secondary">
          {blurb}
        </Typography>
      )}
    </Paper>
  </Box>
);

export default PortalPlaceholderPage;
